import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

export const getBomList = createAsyncThunk("/get-bom-list", async (data, { rejectWithValue }) => {
  try {
    const response = await axios.post(`${baseUrl}bom/api/v1/list`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log("getBomListresponse", response.data);
    return response.data; // ✅ Return only the data
  } catch (error) {
    console.error("Error fetching products r:", error);

    // ✅ Handle errors properly
    return rejectWithValue(error.response?.data?.message || "Failed to fetch products");
  }
});



